import gql from "graphql-tag.macro";

const loadGroupQuery = gql`
    query viewProjectGroup($groupId: ID!) {
        viewProjectGroup(groupId: $groupId) {
            id
            name
            description
            lastUpdated
            members {
                _id
                firstname
                lastname
            }
            hasRoles
            displayName
            hasChildGroups
            path
            created
        }
    }
`;

const loadAllGroupsQuery = gql`
    query loadGroupsInProject {
        currentProject {
            ... on Project {
                _id
                groups {
                    id
                    name
                    description
                    lastUpdated
                    members {
                        _id
                        firstname
                        lastname
                    }
                    hasRoles
                    displayName
                    hasChildGroups
                    path
                    created
                }
            }
        }
    }
`;

const addGroupMutation = gql`
    mutation createProjectGroup($name: String!, $input: ProjectGroupInput) {
        createProjectGroup(name: $name, input: $input) {
            id
            name
            description
            lastUpdated
            members {
                _id
                firstname
                lastname
            }
            hasRoles
            displayName
            hasChildGroups
            path
            created
        }
    }
`;

const updateGroupMutation = gql`
    mutation updateProjectGroup(
        $id: ID!
        $name: String
        $input: ProjectGroupInput
    ) {
        updateProjectGroup(id: $id, name: $name, input: $input) {
            id
            name
            description
            lastUpdated
            members {
                _id
                firstname
                lastname
            }
            hasRoles
            displayName
            hasChildGroups
            path
            created
        }
    }
`;

const updateGroupUsersMutation = gql`
mutation updateGroupUsers (
    $groupId: ID!
    $addUserIds: [ID!]!
    $removeUserIds: [ID!]!
) {
    addAndRemoveUsersProjectGroup(groupId: $groupId, addUserIds: $addUserIds, removeUserIds: $removeUserIds) {
        id
        name
        description
        lastUpdated
        members {
            _id
            firstname
            lastname
        }
        hasRoles
        displayName
        hasChildGroups
        path
        created
    }
}
`;

const deleteGroupMutation = gql`
    mutation deleteProjectGroup($id: ID!) {
        deleteProjectGroup(id: $id)
    }
`;

export const loadGroup = async ({ groupId }, { client }) => {
    const {
        data: { viewProjectGroup: data },
    } = await client.query({
        query: loadGroupQuery,
        variables: { groupId },
    });
    return data;
};

export const loadAllGroups = async ({ client }) => {
    const {
        data: { currentProject: data },
    } = await client.query({
        query: loadAllGroupsQuery,
    });
    return data || {};
};

export const addGroup = async ({ formData: { name, description } }, { client }) => {
    const {
        data: { createProjectGroup: data },
    } = await client.mutate({
        mutation: addGroupMutation,
        variables: { name, input: { description, displayName: name } },
    });
    return data;
};

export const updateGroup = async ({ formData: { id, name, description, displayName } }, { client }) => {
    const {
        data: { updateProjectGroup: data },
    } = await client.mutate({
        mutation: updateGroupMutation,
        variables: { id, name, input: { description, displayName } },
    });
    return data;
};

export const updateGroupUsers = async (
    { groupId, addUserIds = [], removeUserIds = []},
    { client }
) => {
    const {
        data: { addAndRemoveUsersProjectGroup: data },
    } = await client.mutate({
        mutation: updateGroupUsersMutation,
        variables: { groupId, addUserIds, removeUserIds },
    });
    return data;
};

export const deleteGroup = async ({ id }, { client }) => {
    const {
        data: { deleteProjectGroup: data },
    } = await client.mutate({
        mutation: deleteGroupMutation,
        variables: { id },
    });
    return data;
};
